import { ISubscription } from "./ISubscription";
import { IFilter } from "./IFilter";

export class Subscription implements ISubscription {
	id: string | null;

	filter?: IFilter;

	channel: string;

	/**
	 *
	 * @param {string|null} id
	 * @param {IFilter[]|null} filter
	 */
	constructor(id?: string, filter?: IFilter) {
		// id is defined as string, but then is potentially assigned null
		this.id = id ? id : null;
		// id is defined as IFilter, but then is assigned to an optional value, so it may be undefined
		this.filter = filter;

		this.channel = "";
	}
}
